import { Autoplay, Navigation } from "swiper/modules";
import { CategoriesList, LatestArticleList, ProfessionalInsightsList, ReviewsList, SocialContactList } from "../../types/CommonComponents";
import { BlogBoxType } from "../../types/Blog";

export const BlogData: BlogBoxType[] = [
  {
    title: "Revving Up: Exploring the Latest in Automotive Innovation",
    author: "Romeo Roman",
    date: "03/09/2025",
    views: "10K",
    summary:
      "Explore the latest in automotive innovation, from electric engines to advanced driver-assistance systems, and see what's shaping the future of driving.",
    image: "blog/1.jpg",
    authorImage: "car/testimonial/3.jpg",
    masonry: "blog/masonry/1.jpg",
  },
  {
    title: "How to Increase Your Property’s Value",
    author: "Rachel Reid",
    date: "14/02/2025",
    views: "15K",
    summary:
      "Unlock the full potential of your property with these essential tips to boost its value and appeal.",
    image: "blog/2.jpg",
    authorImage: "car/testimonial/2.jpg",
    masonry: "blog/masonry/2.jpg",
    fireBox: true,
  },
  {
    title: "Landing Your Dream Job: Proven Strategies for Success",
    author: "Robert Ross",
    date: "21/07/2025",
    views: "46K",
    summary:
      "Unlock your potential with these proven strategies for landing your dream job and turning aspirations into reality.",
    image: "blog/3.jpg",
    authorImage: "car/testimonial/1.jpg",
    masonry: "blog/masonry/3.jpg",
  },
  {
    title: "Road Warriors: Adventure Awaits with the Perfect Ride",
    author: "Rose Roberts",
    date: "03/12/2025",
    views: "20K",
    summary:
      "Gear up for thrilling journeys with our ultimate guide: Adventure awaits with essential travel tips and must-have gear!",
    image: "blog/4.jpg",
    authorImage: "car/testimonial/4.jpg",
    masonry: "blog/masonry/4.jpg",
    fireBox: true,
  },
  {
    title: "What to Know Before Selling Your Home",
    author: "Ryan Reid",
    date: "28/12/2025",
    views: "18K",
    summary:
      "Discover the essential steps and insights needed to successfully sell your home and maximize its value.",
    image: "blog/5.jpg",
    authorImage: "car/testimonial/5.jpg",
    masonry: "blog/masonry/5.jpg",
    fireBox: true,
  },
  {
    title: "Fueling Passion: Stories and Tips for Car Lovers",
    author: "Rita Rogers",
    date: "29/11/2025",
    views: "35K",
    summary:
      "Fueling Passion: Dive into Inspiring Stories and Expert Tips to Ignite Your Love for Cars.",
    image: "blog/6.jpg",
    authorImage: "car/testimonial/6.jpg",
    masonry: "blog/masonry/6.jpg",
  },
  {
    title: "Career Success: How to Find and Secure Your Ideal Job",
    author: "Rachel Rowe",
    date: "24/08/2025",
    views: "25K",
    summary:
      "Discover the steps to identify your dream job and turn it into reality with actionable strategies and insider tips.",
    image: "blog/7.jpg",
    authorImage: "car/person/1.jpg",
    masonry: "blog/masonry/7.jpg",
  },
  {
    title: "Understanding Property Market Cycles",
    author: "Megan Moore",
    date: "01/03/2025",
    views: "28K",
    summary:
      "Unlocking the Secrets of Property Market Cycles: How to Time Your Investments for Maximum Returns.",
    image: "blog/8.jpg",
    authorImage: "car/person/2.jpg",
    masonry: "blog/masonry/8.jpg",
    fireBox: true,
  },
  {
    title: "Behind the Wheel: Navigating the World of Modern Cars",
    author: "Monica Meyer",
    date: "26/05/2025",
    views: "32K",
    summary:
      "Master modern cars with our guide to advanced features, smart tech, and practical tips for a smoother drive.",
    image: "blog/9.jpg",
    authorImage: "car/person/3.jpg",
    masonry: "blog/masonry/9.jpg",
  },
  {
    title: "How to Choose the Right Car for Your Family",
    author: "Aaron Allen",
    date: "06/12/2025",
    views: "36K",
    summary:
      "The new car market is diverse and constantly evolving, offering various models to fit different budgets and lifestyles.",
    image: "portfolio/13.jpg",
    authorImage: "job/about-slider/4.jpg",
    masonry: "portfolio/13.jpg",
  },
  {
    title: "From Resume to Interview: Crafting Your Path to Career Success",
    author: "Alan Archer",
    date: "02/05/2025",
    views: "28K",
    summary:
      "The job market is highly competitive, and it can be challenging to stand out from the crowd. Transform your job search from a resume submission to an impactful interview with strategies that showcase your path to career success",
    image: "portfolio/14.jpg",
    authorImage: "job/about-slider/5.jpg",
    masonry: "portfolio/14.jpg",
  },
  {
    title: "How to Stand Out in a Competitive Job Market",
    author: "Sophia Shaw",
    date: "29/08/2025",
    views: "30K",
    summary:
      "Mastering the Art of Standing Out in a Competitive Job Market: Key Strategies for Success",
    image: "blog/10.jpg",
    authorImage: "job/about-slider/1.jpg",
    masonry: "blog/masonry/10.jpg",
  },
  {
    title: "Career Growth: Navigating the Path to Your Dream Job",
    author: "Sam Smith",
    date: "06/12/2025",
    views: "42K",
    summary:
      "Master the art of career growth with actionable strategies and insights to guide you toward your dream job.",
    image: "blog/11.jpg",
    authorImage: "job/about-slider/2.jpg",
    masonry: "blog/masonry/11.jpg",
  },
  {
    title: "How to Create a Home Office That Inspires Productivity",
    author: "Sarah Stone",
    date: "01/04/2025",
    views: "13K",
    summary:
      "Transform your home office into a productivity powerhouse with these design and organizational tips.",
    image: "blog/12.jpg",
    authorImage: "job/about-slider/3.jpg",
    masonry: "blog/masonry/12.jpg",
  },
  {
    title: "How to Write a Resume That Will Get You Hired",
    author: "Greg Grant",
    date: "10/01/2025",
    views: "56K",
    summary:
      "A well-written resume is essential for landing a job.Crafting a resume that stands out can be the key to landing your dream job.Here are some tips and strategies to help you write a resume that will get you noticed and ultimately hired.",
    image: "blog/15.jpg",
    authorImage: "job/job-box/1.jpg",
    masonry: "blog/15.jpg",
  },
  {
    title: "How to Stage Your Home for a Quick and Profitable Sale",
    author: "Katie Kent",
    date: "16/10/2025",
    views: "30K",
    summary:
      "Staging your home effectively can significantly impact how quickly and profitably it sells.",
    image: "blog/16.jpg",
    authorImage: "job/job-box/2.jpg",
    masonry: "blog/16.jpg",
    fireBox: true,
  },
  {
    title: "Motoring Mastery: Enhancing Your Driving Experience",
    author: "Ulric Urban",
    date: "04/04/2025",
    views: "39K",
    summary:
      "Discover the keys to an exceptional driving experience with expert tips and techniques for mastering your vehicle.",
    image: "blog/17.jpg",
    authorImage: "job/job-box/3.jpg",
    masonry: "blog/17.jpg",
  },
];

export const LatestArticleData: LatestArticleList[] = [
  {
    image: "18.jpg",
    title: "Essential Tips for Landing Your Ideal Job",
    type: "Job",
    date: "12 June 2023",
  },
  {
    image: "19.jpg",
    title: "Leveraging Networking to Land Your Next Job",
    type: "Job",
    date: "5 March 2024",
  },
  {
    image: "20.jpg",
    title: "A Beginner's Guide to Property Management",
    type: "Property",
    date: "8 March 2024",
  },
];

export const CategoriesData: CategoriesList[] = [
  { icon: "ri-home-4-line", title: "Property", value: "4" },
  { icon: "ri-car-line", title: "Vehicles", value: "5" },
  { icon: "ri-briefcase-line", title: "Job", value: "2" },
  { icon: "ri-megaphone-line", title: "News", value: "3" },
  { icon: "ri-bar-chart-2-line", title: "Investment", value: "8" },
  { icon: "ri-team-line", title: "Community", value: "1" },
];

export const SocialContactData: SocialContactList[] = [
  {
    url: "https://wa.me/+601162914913",
    icon: "ri-whatsapp-line",
    title: "Facebook",
    value: "45.3K",
  },
  {
    url: "https://www.facebook.com/profile.php?id=100082301858224",
    icon: "ri-facebook-line",
    title: "Facebook",
    value: "45.3K",
  },
  // {
  //   url: "https://x.com/",
  //   icon: "ri-twitter-line",
  //   title: "Twitter",
  //   value: "68.3K",
  // },
  // {
  //   url: "https://www.youtube.com/",
  //   icon: "ri-youtube-line",
  //   title: "Youtube",
  //   value: "38.4K",
  // },
  {
    url: "https://www.instagram.com/ccautoworld/?hl=en",
    icon: "ri-instagram-line",
    title: "Instagram",
    value: "87.4K",
  },
  {
    url: "https://www.tiktok.com/@ccautoworld7",
    icon: "ri-tiktok-fill",
    title: "Tiktok",
    value: "42.5K",
  },
];

export const BlogContent1: string =
  "Welcome, road warriors! If you dream of hitting the open road with the perfect ride, you're in the right place. Whether it’s a cross-country trip or a weekend getaway, the right vehicle can turn your journey into an unforgettable adventure.";

export const BlogContent2: string =
  "Choosing the right vehicle transforms every mile into an adventure. In this blog, we’ll explore what makes the perfect road trip vehicle, offer tips for picking your ideal ride, and share inspiring travel stories.";

export const ProfessionalData: ProfessionalInsightsList[] = [
  {
    title: "Know Your Terrain",
    description:
      "Choosing career tools and strategies is like picking the right vehicle for a road trip—align them with your goals for a smooth journey to success.",
  },
  {
    title: "Map Your Route",
    description:
      "Like planning a road trip with a detailed map, outline a clear career path. Set specific, actionable goals and milestones.",
  },
  {
    title: "Maintain Your Vehicle",
    description:
      "A well-maintained vehicle runs smoothly, just as continuous learning and development keep you at the top of your game.",
  },
  {
    title: "Navigate with Confidence",
    description:
      "Road trips often involve unexpected detours and roadblocks. Similarly, being adaptable in your career is key to navigating unforeseen changes.",
  },
  {
    title: "Enjoy the Journey",
    description:
      "Just as a road trip is about the experience as much as the destination, savor your career journey. Celebrate your achievements and milestones along the way.",
  },
];

export const ConclusionData: ProfessionalInsightsList[] = [
  {
    description:
      "In conclusion, embarking on a journey as a road warrior means more than just having the right vehicle; it’s about the spirit of adventure, the freedom of the open road, and the memories made along the way.",
  },
  {
    description:
      "The perfect ride, equipped with the right features and comforts, transforms every trip into an unforgettable experience.",
  },
  {
    description:
      "Whether you’re exploring new destinations, rediscovering familiar routes, or simply enjoying the journey itself, the right vehicle makes all the difference. So gear up, hit the road, and let the adventures unfold. Adventure truly awaits with the perfect ride.",
  },
  {
    description:
      "From the anticipation of departure to the joy of discovering new destinations, and even the comfort of revisiting familiar routes, the right vehicle enhances every aspect of the journey.",
  },
  {
    description:
      "Adventure awaits with the perfect ride, making every journey unforgettable.",
  },
];

export const UnveilingContent1: string =
  "In a world brimming with endless possibilities, the journey itself often holds the most profound experiences. Whether you're traversing scenic highways, exploring hidden gems, or simply seeking a new adventure, the right ride can make all the difference";

export const UnveilingContent2: string =
  "At Road Warriors, we're passionate about helping you find your perfect vehicle. Our expert team is dedicated to providing you with the knowledge and tools you need to make informed decisions and turn your travel dreams into a reality.";

export const AboutData: string =
  "Rose Roberts, a seasoned writer with over a decade of experience, explores technology, lifestyle, and personal development. Her compelling stories and insightful articles have earned her a loyal readership and a trusted voice in the blogosphere.";

export const ReviewsData: ReviewsList[] = [
  {
    name: "Rachel Rowe",
    rating: 4.5,
    image: "car/person/1.jpg",
    timestamp: "10 days Ago",
    message:
      "That sounds fantastic! The right vehicle can make all the difference on your adventures. If you’re looking for tips on choosing the perfect ride or want advice on features to look for, just let me know!",
  },
  {
    name: "Megan Moore",
    rating: 4.5,
    image: "car/person/2.jpg",
    timestamp: "10 days Ago",
    message:
      "Absolutely! The right vehicle can totally transform your adventures. If you need any tips on picking the ideal ride or advice on must-have features, feel free to reach out. I’d be happy to help!",
    isReply: true,
  },
  {
    name: "Monica Meyer",
    rating: 3.5,
    image: "car/person/3.jpg",
    timestamp: "2 Months Ago",
    message:
      "Whether you're heading cross-country or just out for the weekend, the right vehicle transforms your trip. From rugged off-roaders to sleek sedans, find your perfect ride and start your adventure with confidence.",
  },
];

export const BlogSliderImages: string[] = [
  "blog/4.jpg",
  "blog/6.jpg",
  "blog/3.jpg",
  "blog/2.jpg",
  "blog/9.jpg",
  "blog/12.jpg",
  "blog/17.jpg",
  "blog/14.jpg",
  "blog/20.jpg",
];

export const QuoteBoxContent: string =
  "As a beginner in the world of cooking, this blog has been my saving grace. The recipes are easy to follow, and the tips have truly elevated my culinary skills";

export const JobBreadcrumbsContent: string =
  "We’re excited to announce that we’re looking for a talented Business Development to join our fun, transparent, and collaborative team!";

export const BlogInfo: string =
  "Life Is a Journey, Not a Destination: Choose the Ride That Makes Every Mile an Adventure";

// All slider options from swiper plugin

export const BlogTopSlider = {
  modules: [Navigation, Autoplay],
  slidesPerView: 4,
  speed: 2000,
  spaceBetween: 30,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
    354: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    991: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".blog-next-swiper",
    prevEl: ".blog-prev-swiper",
  },
};

export const BlogDetailSlider = {
  loop: true,
  speed: 2000,
  autoplay: false,
  modules: [Navigation, Autoplay],
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
  },
  navigation: {
    nextEl: ".blog-next-detail",
    prevEl: ".blog-prev-detail",
  },
};